import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { pagosApi } from '@/data/api/pagosApi';
const KEY = 'pagos';
const RESERVAS_KEY = 'reservas';
export function usePagosDeReserva(reservaId) {
    return useQuery({
        queryKey: [KEY, reservaId],
        queryFn: () => pagosApi.listarDeReserva(reservaId),
        enabled: Boolean(reservaId),
    });
}
export function useRegistrarPago(reservaId) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (v) => pagosApi.registrar(reservaId, v),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: [KEY, reservaId] });
            qc.invalidateQueries({ queryKey: [RESERVAS_KEY] });
        },
    });
}
export function useReversarPago(reservaId) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ pagoId, motivo }) => pagosApi.reversar(pagoId, motivo),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: [KEY, reservaId] });
            qc.invalidateQueries({ queryKey: [RESERVAS_KEY] });
        },
    });
}
export function useDescuentosDeReserva(reservaId) {
    return useQuery({
        queryKey: ['descuentos', reservaId],
        queryFn: () => pagosApi.listarDescuentos(reservaId),
        enabled: Boolean(reservaId),
    });
}
export function useAplicarDescuento(reservaId) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (datos) => pagosApi.aplicarDescuento(reservaId, datos),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['descuentos', reservaId] });
            qc.invalidateQueries({ queryKey: [RESERVAS_KEY] });
        },
    });
}
export function useQuitarDescuento(reservaId) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (aplicacionId) => pagosApi.quitarDescuento(reservaId, aplicacionId),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['descuentos', reservaId] });
            qc.invalidateQueries({ queryKey: [RESERVAS_KEY] });
        },
    });
}
